import React, { memo } from 'react';
import { classNames } from '../../utils/classNames';

export const Spinner = memo(function Spinner({ label, size = 'md' }) {
	const dimension =
		size === 'sm'
			? 'h-4 w-4 border-2'
			: size === 'lg'
				? 'h-10 w-10 border-[3px]'
				: 'h-6 w-6 border-2';

	return (
		<div className='flex flex-col items-center gap-3'>
			<span
				className={classNames(
					'inline-block animate-spin rounded-full border-zinc-300 border-t-sky-600',
					dimension,
				)}
			/>
			{label ? (
				<p className='text-xs font-medium text-zinc-600'>{label}</p>
			) : null}
		</div>
	);
});

export default Spinner;